const setCarouselControls = carouselWrapper => {
  if (!carouselWrapper) return;
  const carousel = carouselWrapper.querySelector('.carousel-images');
  if (!carousel) return;
  setButtons(carouselWrapper, carousel);
  setIndicator(carouselWrapper, carousel);
  window.addEventListener('resize', () =>
      setIndicator(carouselWrapper, carousel));
};

const moveLeft = carousel => carousel.scroll(
    {left: carousel.scrollLeft - carousel.offsetWidth, behavior: 'smooth'});

const moveRight = carousel => carousel.scroll(
    {left: carousel.scrollLeft + carousel.offsetWidth, behavior: 'smooth'});

const setButtons = (carouselWrapper, carousel) => {
  const btns = carouselWrapper.querySelectorAll('.carousel-controls');
  if (btns.length === 0) return;
  btns[0].addEventListener('click', () => moveLeft(carousel));
  btns[1].addEventListener('click', () => moveRight(carousel));
  const scrollWidth = carousel.scrollWidth - carousel.offsetWidth;
  carousel.addEventListener('scroll', () => setTimeout(() => {
    btns[0].classList.toggle('d-none', carousel.scrollLeft === 0);
    btns[1].classList.toggle('d-none', carousel.scrollLeft === scrollWidth);
  }, 100));
};

const setIndicator = (carouselWrapper, carousel) => {
    const indicators = carouselWrapper.querySelectorAll('.indicator');
    carousel.addEventListener('scroll', () => setTimeout(() => {
      const position = Math.round(carousel.scrollLeft / carousel.offsetWidth);
      indicators.forEach(indicator => indicator.classList.remove('current'));
      indicators[position]?.classList.add('current');
    }, 100));
};

export {setCarouselControls};